// --- 供应点综合管理 --- //

export default [
  {
    name: 'supplyCentreList',
    path: '/supplySystem/:supplyId/supplyCentreManagement/supplyCentreList',
    meta: { title: '供应点列表' },
    component: require('business/supplySystem/supplyCentreSyntheticalManagement/supplyCentreList/list.vue').default
  }
]
